module.exports = __webpack_public_path__ + "img/vr-1.1dc84cd4.webp";